import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import { action } from 'satcheljs/lib/legacy';
import { SubstrateSearchSuggestionsResponse } from 'owa-search-service';
import convertSuggestionToPersonaType from 'owa-recipient-suggestions/lib/util/convertSuggestionToPersonaType';

const DEFAULT_MAX_RESULTS = 20;

export default action('processSubstrateSuggestionsResponse')(
    function processSubstrateSuggestionsResponse(
        resultList: FindRecipientPersonaType[],
        resp: SubstrateSearchSuggestionsResponse,
        appendResults: boolean,
        maxResults?: number,
        returnMaskedRecipients?: boolean
    ) {
        if (!resp || !resp.Groups) {
            throw new Error('Response groups should not be null');
        } else {
            let personaTypeSet: FindRecipientPersonaType[] = [];

            maxResults = maxResults ? maxResults : DEFAULT_MAX_RESULTS;
            maxResults = appendResults ? maxResults - resultList.length : maxResults;
            const transactionId = resp.Instrumentation && resp.Instrumentation.TraceId;
            for (const group of resp.Groups) {
                if (group.Type === 'People') {
                    group.Suggestions.forEach(suggestion => {
                        if (personaTypeSet.length < maxResults) {
                            const personaType = convertSuggestionToPersonaType(
                                suggestion,
                                transactionId,
                                returnMaskedRecipients
                            );
                            personaType && personaTypeSet.push(personaType);
                        }
                    });
                    break;
                }
            }

            if (appendResults) {
                resultList.push(...personaTypeSet);
            } else {
                resultList.splice(0, resultList.length, ...personaTypeSet);
            }
        }
    }
);
